import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { userInfoAtom } from '~atoms';
import { SchedulesOverviewContainer } from '~features/access';

import Page from '../page';

const AccessSchedulesPage = () => {
	const { t } = useTranslation();

	const [userInfo] = useAtom(userInfoAtom);

	return (
		<Page title={t('schedules')}>
			<SchedulesOverviewContainer />
		</Page>
	);
};

export default AccessSchedulesPage;
